// eslint-disable-next-line no-use-before-define
import React from 'react';

const ChannelListHeader = () => {
  return (
    <div className="border-b-1 border-grey-divider-subdued border-solid h-64 flex flex-col justify-center px-16">
      <h1 className="text-h4">Messages</h1>
    </div>
  );
};

export default ChannelListHeader;
